module.exports = __webpack_public_path__ + "img/index-solutions-eea-hover.ab929b9b.png";